import React from "react";
import "./CarouselArrow.css";

export default function CarouselArrow({ direction, onClick }) {
  return (
    <button
      type="button"
      className={`carousel-arrow carousel-arrow--${direction}`}
      onClick={onClick}
      aria-label={direction === "left" ? "Anterior" : "Siguiente"}
    >
      {direction === "left" ? "‹" : "›"}
    </button>
  );
}
